import React, { createContext, useState } from "react";

const initialState = {
  messageToSocket: "",
  _setMessageToSocket: (message: any) => {},
  messageFromSocket: "",
  _setMessageFromSocket: (message: any) => {},
  socket:null,
  _setWebsocketConnection: (ws) => {},
};

export const SocketContext = createContext(initialState);

export const SocketContextProvider = ({ children }) => {
  const [messageToSocket, setMessageToSocket] = useState(
    initialState.messageToSocket
  );
  const [messageFromSocket, setMessageFromSocket] = useState(
    initialState.messageFromSocket
  );
  const [socket, setSocket] = useState(initialState.socket);

  const _setMessageFromSocket = (message) => {
    setMessageFromSocket(message);
  };

  const _setMessageToSocket = (message) => {
    setMessageToSocket(message);
  };

  const _setWebsocketConnection = (ws) => {
    setSocket(ws);
  };
  
  return (
    <SocketContext.Provider value={{
        messageToSocket,
        messageFromSocket,
        _setMessageToSocket,
        _setMessageFromSocket,
        socket,
        _setWebsocketConnection,
        }}>
      {children}
    </SocketContext.Provider>
  );
};
